<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="d-flex align-center">
          <h2 class="headline">
            <span class="font-weight-bold d-flex align-center">
              <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
              My Voucher
            </span>
          </h2>
        </div>
      </v-col>
    </v-row>
    <v-row v-scroll="onScroll">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <template v-for="(discount, idx) in vouchers">
          <v-card :key="idx" class="card-voucher" disabled @click="selectVoucher(discount.id)">
            <div class="card-detail-voucher">
              <div class="discount-store-name">
                {{ discount.store_name }}
              </div>
              <div class="discount-title">
                {{ discount.title }}
              </div>
              <div class="discount-description">
                <div class="discount-description-code">
                  {{ discount.code }}
                </div>
                <div class="discount-description-list" v-html="discount.discount_description" />
              </div>
            </div>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <v-bottom-sheet v-model="sheetDetail" persistent content-class="showFull">
      <v-sheet style="height: 100%; overflow: auto;">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="d-flex align-center">
                <h2 class="headline">
                  <span class="font-weight-bold d-flex align-center">
                    Voucher Detail
                  </span>
                </h2>
                <v-spacer />
                <v-btn text icon color="red lighten-2" @click="closeShowDetail()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <div class="__bg-discount-responsive">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="360" height="128" viewBox="0 0 360 128" class="__bg-discount">
            <defs>
              <linearGradient id="a" x1="0.5" y1="-0.21" x2="0.695" y2="1.209" gradientUnits="objectBoundingBox">
                <template v-if="colorTheme === 'theme-1'">
                  <stop offset="0" stop-color="#76CCFC" />
                  <stop offset="1" stop-color="#38B8FF" />
                </template>
                <template v-else-if="colorTheme === 'theme-2'">
                  <stop offset="0" stop-color="#2AF598" />
                  <stop offset="1" stop-color="#009EFD" />
                </template>
                <template v-else-if="colorTheme === 'theme-3'">
                  <stop offset="0" stop-color="#F6D365" />
                  <stop offset="1" stop-color="#FDA085" />
                </template>
                <template v-else-if="colorTheme === 'theme-4'">
                  <stop offset="0" stop-color="#F8BB08" />
                  <stop offset="1" stop-color="#E50025" />
                </template>
                <template v-else-if="colorTheme === 'theme-5'">
                  <stop offset="0" stop-color="#D70B20" />
                  <stop offset="1" stop-color="#A71F2D" />
                </template>
                <template v-else-if="colorTheme === 'theme-6'">
                  <stop offset="0" stop-color="#868F96" />
                  <stop offset="1" stop-color="#596164" />
                </template>
                <template v-else-if="colorTheme === 'theme-7'">
                  <stop offset="0" stop-color="#F1F21B" />
                  <stop offset="1" stop-color="#111111" />
                </template>
                <template v-else-if="colorTheme === 'theme-8'">
                  <stop offset="0" stop-color="#667EEA" />
                  <stop offset="1" stop-color="#764BA2" />
                </template>
              </linearGradient>
              <clipPath id="c">
                <rect class="a" width="360" height="128" />
              </clipPath>
              <linearGradient id="d" y1="0" x2="0.5" y2="1" xlink:href="#a" />
            </defs>
            <rect class="a" width="360" height="128" />
            <text class="b" transform="translate(158 84)">
              <tspan x="0" y="0">
                %
              </tspan>
            </text>
            <g class="c">
              <circle class="d" cx="85" cy="85" r="85" transform="translate(-21 33)" />
              <circle class="d" cx="85" cy="85" r="85" transform="translate(211 -72)" />
            </g>
          </svg>
        </div>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="d-voucher-title">
                {{ voucher.title }}
              </div>
              <div class="d-voucher-description" v-html="voucher.discount_description" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="__menu-bottom menu-full">
                <v-btn type="submit" color="primary" block x-large class="text-none" @click="useVoucher(voucher.id)">
                  Gunakan Voucher
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import { debounce } from 'debounce'
import {
  getData as getDataDiscount,
  getDataDetail as getDataDetailDiscount
} from '@/api/discount'
export default {
  data() {
    return {
      settingScroll: false,
      sheetDetail: false,
      params: {
        page: 1,
        per_page: 10
      },
      vouchers: [],
      voucher: {},
      dataInCartTakeaway: {},
      dataInCartDelivery: {},
      dataInCartDinein: {},
      dataInCartReservation: {}
    }
  },
  computed: {
    colorTheme() {
      let color = 'theme-1'
      if (this.$store.state.selected_store) {
        if (this.$store.state.selected_store.setting) {
          if (this.$store.state.selected_store.setting.online_color_id === 1) {
            color = 'theme-1'
          } else if (this.$store.state.selected_store.setting.online_color_id === 2) {
            color = 'theme-2'
          } else if (this.$store.state.selected_store.setting.online_color_id === 3) {
            color = 'theme-3'
          } else if (this.$store.state.selected_store.setting.online_color_id === 4) {
            color = 'theme-4'
          } else if (this.$store.state.selected_store.setting.online_color_id === 5) {
            color = 'theme-5'
          } else if (this.$store.state.selected_store.setting.online_color_id === 6) {
            color = 'theme-6'
          } else if (this.$store.state.selected_store.setting.online_color_id === 7) {
            color = 'theme-7'
          } else if (this.$store.state.selected_store.setting.online_color_id === 8) {
            color = 'theme-8'
          }
        }
      }
      return color
    }
  },
  created() {
    this.fetchVouchers()
  },
  methods: {
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    },
    onScroll: debounce(async function(e) {
      if (this.settingScroll === false) {
        if ((window.innerHeight + window.scrollY + 150) >= document.body.offsetHeight) {
          this.fetchVouchers()
        }
      }
    }, 500),
    async fetchVouchers() {
      var _params = {
        page: this.params.page++,
        per_page: this.params.per_page
      }
      try {
        const { data } = await getDataDiscount(_params)
        this.settingScroll = (data.data.length < this.params.per_page)
        this.$store.state.loading_axios = false
        for (var i in data.data) {
          this.vouchers.push(data.data[i])
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async selectVoucher(id) {
      this.sheetDetail = true
      this.voucher = {}
      try {
        const { data } = await getDataDetailDiscount(id)
        this.$store.state.loading_axios = false
        this.voucher = data.data
        this.voucher.discount_amount = Number(this.voucher.discount_amount)
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async useVoucher(id) {
      if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_OL-TAKE-AWAY'))) {
        this.dataInCartTakeaway = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_OL-TAKE-AWAY'))
        this.dataInCartTakeaway.discount_voucher_id = id
        await this.$store.dispatch('saveDataCartTakeAway', this.dataInCartTakeaway)
      }
      if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))) {
        this.dataInCartDelivery = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))
        this.dataInCartDelivery.discount_voucher_id = id
        await this.$store.dispatch('saveDataCartDelivery', this.dataInCartDelivery)
      }
      if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN'))) {
        this.dataInCartDinein = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN'))
        this.dataInCartDinein.discount_voucher_id = id
        await this.$store.dispatch('saveDataCartDineIn', this.dataInCartDinein)
      }
      if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_RESERVATION'))) {
        this.dataInCartReservation = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_RESERVATION'))
        this.dataInCartReservation.discount_voucher_id = id
        await this.$store.dispatch('saveDataCartReservation', this.dataInCartReservation)
      }
    },
    closeShowDetail() {
      this.sheetDetail = false
    }
  }
}
</script>
